import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { isObject } from 'lodash';
import PropTypes from 'prop-types';

import { options } from '../DynamicTypography';
import {
  LessonButtons,
  LessonDescArticle, LessonDescButtonsContainer, LessonDescContainer, LessonDescDescription,
  LessonDescTextContainer, LessonDescTitle, NextButton,
  PreviewDescription, PreviewTitle, WatchVideoButton
} from './LessonDescriptionCard.styles';

import { useLessonValues } from '../../contexts/LessonContext';

const LessonDescriptionCard = ({
  title,
  description,
  primaryDisabled,
  onPrimaryClick,
  secondaryDisabled,
  onSecondaryClick,
  isPreview,
  color
}) => {
  const { getLessonValue } = useLessonValues();

  const secondaryColor = getLessonValue('secondaryColor');

  const lessonColor = color || secondaryColor;

  return (
    <LessonDescContainer isPreview={isPreview}>
      <LessonDescTextContainer>
        <LessonDescArticle isPreview={isPreview}>
          Article
        </LessonDescArticle>
        {isPreview
          ? <PreviewTitle>{title}</PreviewTitle>
          : (
            <LessonDescTitle secondaryColor={lessonColor}>
              {title}
            </LessonDescTitle>
          )}
        {
          isPreview
            ? (
              <PreviewDescription secondaryColor={lessonColor}>
                {isObject(description)
                  ? documentToReactComponents(description, options)
                  : description}
              </PreviewDescription>
            )
            : (
              <LessonDescDescription>
                {isObject(description)
                  ? documentToReactComponents(description, options)
                  : description}
              </LessonDescDescription>
            )
        }
      </LessonDescTextContainer>
      {isPreview ? (
        <LessonDescButtonsContainer container>
          <WatchVideoButton
            sx={(theme) => ({
              border: `1px solid ${theme.palette.focus00.main}`,
              color: theme.palette.focus00.main,
              display: 'none',
              [theme.breakpoints.up('md')]: {
                display: 'flex'
              }
            })}
            onClick={onSecondaryClick}
            disabled={secondaryDisabled}
          >
            Watch video
          </WatchVideoButton>
          <LessonButtons
            onClick={onPrimaryClick}
            disabled={primaryDisabled}
            sx={(theme) => ({
              backgroundColor: theme.palette.focus00.main,
              color: theme.palette.focus90.main,
              display: 'none',
              '@media (pointer: coarse)': {
                '&:hover': {
                  backgroundColor: theme.palette.focus00.main
                },
                '&:active': {
                  backgroundColor: '#27ADB3'
                }
              },
              '@media (pointer: fine)': {
                '&:hover': {
                  backgroundColor: '#27ADB3'
                }
              },
              [theme.breakpoints.up('md')]: {
                display: 'flex'
              }
            })}
          >
            Continue
          </LessonButtons>
        </LessonDescButtonsContainer>
      ) : (
        <NextButton
          onClick={onPrimaryClick}
          sx={(theme) => ({
            backgroundColor: theme.palette.focus00.main,
            color: theme.palette.focus90.main,
            display: 'none',
            '@media (pointer: coarse)': {
              '&:hover': {
                backgroundColor: theme.palette.focus00.main
              },
              '&:active': {
                backgroundColor: '#27ADB3'
              }
            },
            '@media (pointer: fine)': {
              '&:hover': {
                backgroundColor: '#27ADB3'
              }
            },
            [theme.breakpoints.up('md')]: {
              display: 'flex'
            }
          })}
        >
          Next
        </NextButton>
      )}
    </LessonDescContainer>
  );
};

LessonDescriptionCard.propTypes = {
  // The title of the lesson
  title: PropTypes.string.isRequired,
  // The description of the lesson
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  // The function for the Continue button
  primaryDisabled: PropTypes.bool,
  onPrimaryClick: PropTypes.func,
  // The function for the Watch Video  button
  secondaryDisabled: PropTypes.bool,
  onSecondaryClick: PropTypes.func,
  // Boolean to know if should be render on preview mode (first lesson step)
  isPreview: PropTypes.bool,
  color: PropTypes.string
};

export default LessonDescriptionCard;
